// @TODO -Delete if no longer needed
import React from "react";
import { Typography } from "@mui/material";
import Badge from "@components/Badge/Badge";
import { MOVEMENT_SERVICE_STATUS_TO_BADGE } from "../movementServiceStatus.mapper";
import type { MovementServiceSectionField } from "../types";

export type BadgeType = "success" | "warning" | "error";

interface MovementServiceSummaryProps {
  movementTypeLabel: string;
  requestNumber: number;
  status: string;
  summaryFields: MovementServiceSectionField[];
  taskStatus?: string;
  claimOwnerName?: string;
  showHeader?: boolean;
}

export const STATUS_TO_BADGE: Record<string, BadgeType> = {
  "Approved": "success",
  "Pending Approval": "warning",
  "Completed": "success",
  "Closed": "success",
  "Cancelled": "error",
  "Rejected": "error",
  // Merge with backend status mappings
  ...MOVEMENT_SERVICE_STATUS_TO_BADGE,
};

const MovementServiceSummary: React.FC<MovementServiceSummaryProps> = ({
  movementTypeLabel,
  requestNumber,
  status,
  summaryFields,
  taskStatus,
  claimOwnerName,
  showHeader = true,
}) => {
  const badgeType = STATUS_TO_BADGE[status] ?? "warning";

  return (
    <div className="rounded-lg border border-[#E6EDF2] bg-white p-6 flex flex-col gap-4">
      {showHeader ? (
        <div className="flex flex-wrap items-start justify-between gap-4">
          <div>
            <Typography variant="h6" className="text-slate-900">
              {movementTypeLabel} · Movement Service - {requestNumber}
            </Typography>
            <div className="mt-2 flex flex-wrap items-center gap-3">
              <Badge label={status} type={badgeType} bold />
              {taskStatus ? (
                <span className="text-sm text-slate-500">
                  Task status: <span className="text-slate-900 font-medium">{taskStatus}</span>
                  {claimOwnerName ? ` · Claimed by ${claimOwnerName}` : ""}
                </span>
              ) : null}
            </div>
          </div>
        </div>
      ) : taskStatus ? (
        <div className="flex flex-wrap items-center gap-3 text-sm text-slate-500">
          <span>
            Task status: <span className="text-slate-900 font-medium">{taskStatus}</span>
            {claimOwnerName ? ` · Claimed by ${claimOwnerName}` : ""}
          </span>
        </div>
      ) : null}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {summaryFields.map((field) => (
          <div key={`summary-${field.labelKey}`} className="flex flex-col space-y-1">
            <span className="text-xs uppercase tracking-wide text-slate-500">{field.labelKey}</span>
            <span className="text-sm font-medium text-slate-900">{field.value ?? "-"}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MovementServiceSummary;
